import { __ } from "@wordpress/i18n";
import React, { useState } from 'react';
import Hint from '../components/Hint/Hint';
import InfoBox from '../components/InfoBox/InfoBox';
import Switch from '../components/Switch/Switch';
import { useMenu } from '../contexts/MenuContext';
import withForm from '../layouts/withForm';
import apiFetch from "@wordpress/api-fetch";
const LoginActionLoginSettings = ({handleChange}) => {
    const {
        settingData
    } = useMenu();
    // const [userID, setUserID] = useState('')
    // const [processing, setProcessing] = useState(false)
    // const [processingRing, setProcessingRing] = useState(false)
    // const [processingTick, setProcessingTick] = useState(false)
    
    // Extract options with defaults
    // const handleAction = async () => {
    //     if (userID) {
    //         const confirmed = window.confirm(__('Are you sure you want to proceed?', 'ultimate-security'));
    //         if (confirmed) {
    //             setProcessing(true);
    //             setProcessingRing(true);

    //             try {
    //                 const result = await apiFetch({
    //                     path: '/ultimate-security/v1/force-user-logout',
    //                     method: 'POST',
    //                     data: {
    //                         user_id: userID,
    //                         security: ultimate_security_ajax_obj?.security || "",
    //                     },
    //                 });

    //                 if (result.success) {
    //                     setProcessingRing(false);
    //                     setProcessingTick(true);
    //                     setTimeout(() => {
    //                         setProcessingTick(false);
    //                         setProcessing(false);
    //                     }, 1000);
    //                 }
    //             } catch (error) {
    //                 console.error('API error:', error);
    //             } finally {
    //                 setProcessing(false);
    //                 setProcessingRing(false);
    //             }
    //         }
    //     }
    // };

    // Main content (inside the form container)
    return (
        <>
            <div className="setting-unit pb-lg mb-lg border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Enable Active Logins Logic", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Toggle this setting to activate the logic for managing active user sessions.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("No Hint", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="login.active_logins.enable"
                                    checked={settingData?.login?.active_logins?.enable}
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="setting-unit pb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Maximum Active Logins", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Set the max active login sessions a user can have.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("No Hint", "ultimate-security")}/>
                                    <input 
                                        className="form-control"
                                        type="number"
                                        min="0"
                                        value={settingData?.login?.active_logins?.max_session}
                                        onChange={(e) => handleChange('login.active_logins.max_session', e.target.value)}
                                    />
                                </div>
                                <div className="content-below-with-hint mt-2">                                    
                                    <InfoBox className="small-infobox" title={__( "Note", "ultimate-security" )} content={__( "If this limit is reached, the next login request will fail and the user will have to logout from one device to continue.", "ultimate-security" )} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="setting-unit">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Force Logout", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("End all active sessions for a specific user.", "ultimate-security")}</p>
                            
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("No Hint", "ultimate-security")}/>
                                    <input 
                                        className="form-control"
                                        type="text"
                                        value={userID}
                                        onChange={(e) => setUserID(e.target.value)}
                                    />
                                </div>
                                <div className="content-below-with-hint mt-2">                                    
                                    <p className="pl-body text-text">{__( "Enter the user ID or username in the field to immediately log them out from all devices.", "ultimate-security" )}</p>
                                    <div className="d-flex align-items-center gap-2 mt-2">                                    
                                        <button 
                                            type="button" 
                                            className="button button-link" 
                                            onClick={handleAction}
                                            disabled={processing}
                                        >
                                            {
                                                processing ? __( "Processing...", "ultimate-security" ) : __( "Force Logout", "ultimate-security" )
                                            }
                                        </button>
                                        {processingRing && <span className="lds-ring"><span></span><span></span><span></span><span></span></span>}
                                        {processingTick && <img src={ultimate_security_ajax_obj.imageUrl+'success-tick.svg'}/>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
        </>
    )
}


export default withForm(LoginActionLoginSettings, 'login.active_logins');
